// 按需引入
import Vue from "vue";
import {
  Image,
  Carousel,
  CarouselItem,
  Pagination,
  Breadcrumb,
  BreadcrumbItem,
  Input,
  InputNumber,
  MessageBox,
  Message,
  Form,
  FormItem,
  Scrollbar,
  Select,
  Option,
  Checkbox
} from "element-ui";

Vue.use(Image); // 图片懒加载 lazy
Vue.use(Carousel); // 轮播图
Vue.use(CarouselItem); // 轮播图配套
Vue.use(Pagination); // 分页器
Vue.use(Breadcrumb); // 面包屑
Vue.use(BreadcrumbItem); // 面包屑配套
Vue.use(Input); // 面包屑配套
Vue.use(InputNumber); // 计数
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Scrollbar);
Vue.use(Select);
Vue.use(Option);
Vue.use(Checkbox);

Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$message = Message;
